// src/screens/auth/RegisterScreen.js
// 47차: console.error 제거
// 50차: registerWithEmail 호출 시 agreedAt(동의 시점 ISO string) 전달
// 51차: 색 theme.js 단일화 — COLORS 참조 / 가입 축하 포인트 초록 통일, 골드버튼 텍스트 ON_GOLD
// 74차: 닉네임에 "관리자" 등 예약어가 부분 포함돼도 막도록 검증 추가(기존엔 정확히 일치할
//       때만 막는 authService의 RESERVED_NICKNAMES만 있어서 "관리자123" 같은 건 통과했음)
// 74차: 가입 완료 후 navigation.navigate('Main',...)가 AppStack의 자동 로그인 이동
//       effect와 경쟁해 Main이 먼저 뜨고 이 화면은 스택에 남아 계속 로딩 상태로 보이던
//       문제 — authRedirectSuppressed로 가입 처리 중 AppStack의 자동 이동을 보류하고,
//       축하 화면을 다 보여준 뒤 보류를 풀어 AppStack이 한 번만 이동하게 함
// 74차: 헤더 워드마크 "Escape Room" → "UNLOCK"으로 통일
// 74차: 약관 동의 체크박스에 이용약관/개인정보처리방침 "보기" 링크 추가(LegalScreen 신규 화면 연결)
// 74차: 이메일 인증 메일 발송(authService.registerWithEmail) 후 안내 문구 추가
// 74차: generateRandomNickname / BLOCKED_NICKNAME_WORDS export — SocialOnboardingScreen.js가
//       SNS 신규가입 온보딩에서 동일한 닉네임 생성/검증 규칙을 재사용
// 76차: 커스텀 헤더(로고+"로그인/회원가입" 링크) → 공통 AppHeader로 교체(rightElement로
//       동일 링크/동작 유지)
// 77차: 동작하지 않던(disabled) "Google로 계속하기" 버튼 + "또는 이메일로 회원가입" 구분선
//       제거 — 이 화면은 이미 이메일 전용 가입 화면이라 불필요(SNS 가입은 LoginScreen.js).
//       헤더/하단 "로그인" 링크가 Main>MyPage로 이동해 비회원에게 또 다른 안내 화면을
//       보여주던 버그 수정 — LoginScreen 라우트로 직접 이동하도록 변경.
//       닉네임을 빈 값으로 두지 않고 화면 진입 시 바로 랜덤 닉네임으로 채움.
// 78차: 헤더 링크/랜덤 버튼/약관 보기 링크/가입 버튼/로그인 링크를 공용
// GradientButton/SecondaryButton/TextButton으로 교체

import React, { useState, useCallback, useEffect } from 'react';
import { showAlert } from '../../components/common/AppAlert';
import {
  View, Text, TextInput, TouchableOpacity,
  StyleSheet, ScrollView, ActivityIndicator,
  Platform, KeyboardAvoidingView,
} from 'react-native';
import { registerWithEmail } from '../../services/authService';
import { useAuth } from '../../contexts/AuthContext';
import AppHeader from '../../components/common/AppHeader';
import GradientButton from '../../components/common/GradientButton';
import { SecondaryButton, TextButton } from '../../components/common/Buttons';
import { RewardIcon, CheckmarkIcon, IconLabel } from '../../components/common/Icons';
import { COLORS } from '../../constants/theme';

export const BLOCKED_NICKNAME_WORDS = ['관리자','어드민','admin','Admin','ADMIN','총관리','슈퍼','super','Super','SUPER'];

const GOLD = COLORS.gold;
const BG = COLORS.bg;
const SURFACE = COLORS.surface;
const BORDER = 'rgba(212,168,67,0.2)';
const TEXT = COLORS.text;
const TEXT_SEC = COLORS.textSec;
const TEXT_MUTED = 'rgba(255,255,255,0.35)';
const GREEN = COLORS.green;
const ON_GOLD = COLORS.onGold;

const ADJECTIVES = ['신비로운','용감한','빠른','영리한','어두운','날카로운','조용한','강인한'];
const NOUNS = ['탐정','모험가','해커','도전자','전략가','파수꾼','추적자'];
// 74차: SocialOnboardingScreen에서도 동일한 랜덤 닉네임 생성을 쓰기 위해 export
export const generateRandomNickname = () => {
  const adj = ADJECTIVES[Math.floor(Math.random() * ADJECTIVES.length)];
  const noun = NOUNS[Math.floor(Math.random() * NOUNS.length)];
  const num = Math.floor(Math.random() * 999) + 1;
  return `${adj}${noun}${num}`;
};

const SuccessScreen = ({ nickname }) => (
  <View style={sc.wrap}>
    <Text style={sc.icon}>🎉</Text>
    <Text style={sc.title}>회원가입 완료!</Text>
    <Text style={sc.name}>{nickname}님,{'\n'}환영합니다!</Text>
    <IconLabel Icon={RewardIcon} size={sc.point.fontSize || 14} color={sc.point.color} textStyle={sc.point}>가입 축하 포인트 500P 지급!</IconLabel>
    <Text style={sc.verifyNotice}>✉️ 인증 메일을 보내드렸어요, 메일함을 확인해주세요.</Text>
    <Text style={sc.desc}>잠시 후 자동으로 이동합니다...</Text>
    <ActivityIndicator color={GOLD} style={{ marginTop: 16 }} />
  </View>
);
const sc = StyleSheet.create({
  wrap: { flex: 1, justifyContent: 'center', alignItems: 'center', paddingHorizontal: 40 },
  icon: { fontSize: 64, marginBottom: 20 },
  title: { fontSize: 26, fontWeight: '900', color: GOLD, marginBottom: 12 },
  name: { fontSize: 18, fontWeight: '700', color: TEXT, textAlign: 'center', lineHeight: 28, marginBottom: 12 },
  point: { fontSize: 14, color: GREEN, fontWeight: '700', marginBottom: 8 },
  verifyNotice: { fontSize: 12, color: TEXT_SEC, marginBottom: 16, textAlign: 'center' },
  desc: { fontSize: 13, color: TEXT_MUTED },
});

export default function RegisterScreen({ navigation }) {
  const { isLoggedIn, authRedirectSuppressed, adminRole, setAuthRedirectSuppressed, refreshProfile } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [nickname, setNickname] = useState(() => generateRandomNickname());
  const [inviterUid, setInviterUid] = useState(''); // 80차 계속: 친구 초대 리워드(선택)
  const [agreed, setAgreed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [finalNickname, setFinalNickname] = useState('');

  // 78차 56차: AppStack이 외부 ref(navRef)로 navigate/reset/goBack을 호출하는 중앙집중
  // 방식이 실기기에서 JS 라우트 상태는 맞게 바꾸면서도 네이티브 화면 전환은 실제로
  // 트리거하지 못하는 것으로 확인됨(하드웨어 뒤로가기로만 걷힘) — 이 화면 자신의
  // `navigation` prop으로 직접 goBack()하는, LoginScreen이 원래 갖고 있던 것과 동일한
  // 패턴으로 되돌림(화면 스스로 자신을 닫는 것만 신뢰성 있게 동작함).
  useEffect(() => {
    if (isLoggedIn && !authRedirectSuppressed) {
      navigation.goBack();
      if (adminRole === 'store' || adminRole === 'super') {
        navigation.navigate('Main');
      } else {
        // 80차 계속: 회원가입 직후 모집 게시판으로 원턴 유도 — HomeScreen.js가 이
        // 파라미터로 최초 1회 배너를 보여줌.
        navigation.navigate('Main', { screen: 'Home', params: { justSignedUp: true } });
      }
    }
  }, [isLoggedIn, authRedirectSuppressed, adminRole]);

  const handleRandomNickname = useCallback(() => {
    setNickname(generateRandomNickname());
  }, []);

  const validate = () => {
    if (!email.includes('@')) { showAlert('입력 오류', '올바른 이메일을 입력해주세요.'); return false; }
    if (password.length < 8) { showAlert('입력 오류', '비밀번호는 8자 이상이어야 합니다.'); return false; }
    if (password !== passwordConfirm) { showAlert('입력 오류', '비밀번호가 일치하지 않습니다.'); return false; }
    if (!agreed) { showAlert('약관 동의', '이용약관 및 개인정보처리방침에 동의해주세요.'); return false; }
    if (nickname.trim() && BLOCKED_NICKNAME_WORDS.some(w => nickname.includes(w))) {
      showAlert('입력 오류', '닉네임에 사용할 수 없는 단어가 포함되어 있어요.'); return false;
    }
    return true;
  };

  const handleRegister = async () => {
    if (!validate()) return;
    try {
      setLoading(true);
      setAuthRedirectSuppressed(true);
      const finalName = nickname.trim() || generateRandomNickname();
      // 50차: 동의 시점을 agreedAt으로 전달
      await registerWithEmail({
        email:    email.trim(),
        password,
        nickname: finalName,
        agreedAt: new Date().toISOString(),
        inviterUid: inviterUid.trim(),
      });
      // 78차 56차: AuthContext의 onAuthStateChanged가 users 문서 생성보다 먼저 발동해
      // getUserProfile이 빈 값(null)을 받고 그대로 방치되던 경쟁상태 — SNS 온보딩
      // (ensureSocialUserDoc)엔 이미 있던 refreshProfile() 호출이 이메일 가입 경로에만
      // 빠져있었음. 문서 생성이 끝난 지금 시점엔 확실히 존재하므로 재조회로 닫음.
      await refreshProfile();

      setFinalNickname(finalName);
      setSuccess(true);

      setTimeout(() => {
        // 74차: 여기서 직접 navigate 하지 않고 보류만 해제 — AppStack의 자동 이동
        // effect가 한 번만 Main으로 이동시킨다 (이중 네비게이션 경쟁 제거)
        setAuthRedirectSuppressed(false);
      }, 1500);
    } catch (e) {
      setAuthRedirectSuppressed(false);
      // 47차: console.error 제거
      const msg =
        e.code === 'auth/email-already-in-use' ? '이미 사용 중인 이메일입니다.' :
        e.code === 'auth/weak-password' ? '비밀번호가 너무 약합니다. 8자 이상으로 설정해주세요.' :
        e.code === 'auth/invalid-email' ? '올바르지 않은 이메일 형식입니다.' :
        e.code === 'auth/network-request-failed' ? '네트워크 연결을 확인해주세요.' :
        e.message || '회원가입에 실패했습니다. 다시 시도해주세요.';
      showAlert('오류', msg);
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <View style={s.container}>
        <AppHeader />
        <View style={{ flex: 1, justifyContent: 'center' }}>
          <SuccessScreen nickname={finalNickname} />
        </View>
      </View>
    );
  }

  return (
    <View style={s.container}>
      <AppHeader rightElement={
        <TextButton label="로그인 / 회원가입" onPress={() => navigation.replace('Login')} textStyle={s.headerRight} style={{ alignSelf: 'flex-end' }} />
      } />
      <KeyboardAvoidingView behavior={Platform.OS === 'ios' ? 'padding' : undefined} style={{ flex: 1 }}>
        <ScrollView contentContainerStyle={s.inner} keyboardShouldPersistTaps="handled" showsVerticalScrollIndicator={false}>
          <View style={s.card}>
            <Text style={s.title}>회원가입</Text>

            <Text style={s.label}>이메일</Text>
            <TextInput
              style={s.input}
              placeholder="이메일을 입력해주세요"
              placeholderTextColor={TEXT_MUTED}
              value={email}
              onChangeText={setEmail}
              keyboardType="email-address"
              autoCapitalize="none"
              autoCorrect={false}
            />

            <Text style={s.label}>비밀번호</Text>
            <TextInput
              style={s.input}
              placeholder="영문+특수문자 포함 8자 이상"
              placeholderTextColor={TEXT_MUTED}
              value={password}
              onChangeText={setPassword}
              secureTextEntry
            />

            <Text style={s.label}>비밀번호 확인</Text>
            <TextInput
              style={s.input}
              placeholder="비밀번호를 다시 입력해주세요"
              placeholderTextColor={TEXT_MUTED}
              value={passwordConfirm}
              onChangeText={setPasswordConfirm}
              secureTextEntry
            />

            <Text style={s.label}>닉네임 <Text style={s.optional}>(선택)</Text></Text>
            <View style={s.nicknameRow}>
              <TextInput
                style={[s.input, s.nicknameInput]}
                placeholder="미입력 시 랜덤 닉네임 설정"
                placeholderTextColor={TEXT_MUTED}
                value={nickname}
                onChangeText={setNickname}
                autoCorrect={false}
              />
              <SecondaryButton label="🎲 랜덤" onPress={handleRandomNickname} style={s.randomBtn} />
            </View>

            {/* 80차 계속: 친구 초대 리워드 — 초대한 사람 uid를 코드로 그대로 사용(별도
                발급 인프라 없음), 초대한 사람에게 앱 공유 버튼으로 받은 코드를 그대로
                붙여넣으면 됨. 비워두면 그냥 무시(applyReferral 내부에서 조용히 스킵). */}
            <Text style={s.label}>초대코드 <Text style={s.optional}>(선택)</Text></Text>
            <TextInput
              style={s.input}
              placeholder="친구에게 받은 초대코드를 입력해주세요"
              placeholderTextColor={TEXT_MUTED}
              value={inviterUid}
              onChangeText={setInviterUid}
              autoCapitalize="none"
              autoCorrect={false}
            />

            <TouchableOpacity style={s.agreeRow} onPress={() => setAgreed(!agreed)}>
              <View style={[s.checkbox, agreed && s.checkboxActive]}>
                {agreed && <CheckmarkIcon size={s.checkmark.fontSize || 12} color={s.checkmark.color} />}
              </View>
              <Text style={s.agreeText}>이용약관 및 개인정보처리방침에 동의합니다 (필수)</Text>
            </TouchableOpacity>
            <View style={s.agreeLinksRow}>
              <TextButton label="이용약관 보기" onPress={() => navigation.navigate('Terms')} textStyle={s.agreeLink} />
              <Text style={s.agreeLinkDot}> · </Text>
              <TextButton label="개인정보처리방침 보기" onPress={() => navigation.navigate('Privacy')} textStyle={s.agreeLink} />
            </View>

            <GradientButton
              label={loading ? '가입 중...' : '회원가입'}
              onPress={handleRegister}
              disabled={loading}
              style={s.registerBtn}
              textStyle={s.registerBtnText}
            />

            <View style={s.loginRow}>
              <Text style={s.loginText}>이미 계정이 있으신가요? </Text>
              <TextButton label="로그인" onPress={() => navigation.replace('Login')} textStyle={s.loginLink} />
            </View>
          </View>
        </ScrollView>
      </KeyboardAvoidingView>
    </View>
  );
}

const s = StyleSheet.create({
  container: { flex: 1, backgroundColor: BG },
  inner: { flexGrow: 1, paddingBottom: 40 },
  headerRight: { fontSize: 13, color: TEXT_SEC },
  card: { marginHorizontal: 16, backgroundColor: SURFACE, borderRadius: 16, padding: 24, borderWidth: 1, borderColor: BORDER },
  title: { fontSize: 24, fontWeight: '900', color: TEXT, textAlign: 'center', marginBottom: 20 },
  label: { color: TEXT, fontSize: 13, fontWeight: '600', marginBottom: 7 },
  optional: { color: TEXT_MUTED, fontWeight: '400' },
  input: { backgroundColor: '#0d0d1a', borderRadius: 10, borderWidth: 1, borderColor: BORDER, paddingHorizontal: 14, height: 50, color: TEXT, fontSize: 14, marginBottom: 14 },
  nicknameRow: { flexDirection: 'row', gap: 8 },
  nicknameInput: { flex: 1 },
  randomBtn: { height: 50, marginBottom: 14, justifyContent: 'center' },
  agreeRow: { flexDirection: 'row', alignItems: 'center', gap: 10, marginBottom: 20 },
  checkbox: { width: 20, height: 20, borderRadius: 4, borderWidth: 1.5, borderColor: BORDER, justifyContent: 'center', alignItems: 'center' },
  checkboxActive: { backgroundColor: GOLD, borderColor: GOLD },
  checkmark: { color: ON_GOLD, fontSize: 13, fontWeight: '900' },
  agreeText: { color: TEXT_SEC, fontSize: 13, flex: 1 },
  agreeLinksRow: { flexDirection: 'row', alignItems: 'center', marginTop: -10, marginBottom: 20, paddingLeft: 30 },
  agreeLink: { color: TEXT_MUTED, fontSize: 12, textDecorationLine: 'underline' },
  agreeLinkDot: { color: TEXT_MUTED, fontSize: 12 },
  registerBtn: { marginBottom: 20 },
  registerBtnText: { fontSize: 17 },
  loginRow: { flexDirection: 'row', alignItems: 'center', justifyContent: 'center' },
  loginText: { color: TEXT_MUTED, fontSize: 14 },
  loginLink: { color: TEXT, fontSize: 14, fontWeight: '800' },
});